import { FC } from "react"

import { ListItemText, Menu, MenuItem } from "@mui/material"
import { useTranslation } from "react-i18next"

interface IProps {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
  onCreateNew: () => void
  onUploadImport: () => void
}

/**
 * Shared "Add Group" dropdown — mounted by the top-bar button and the ghost ADD GROUP
 * card (empty state uses two direct CTAs instead). This component only wires the menu.
 */
const AddGroupMenu: FC<IProps> = ({
  anchorEl,
  open,
  onClose,
  onCreateNew,
  onUploadImport,
}) => {
  const { t } = useTranslation()

  const pick = (fn: () => void) => () => {
    onClose()
    fn()
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      MenuListProps={{ sx: { pt: 0, pb: 0 } }}
    >
      <MenuItem onClick={pick(onCreateNew)}>
        <ListItemText
          primaryTypographyProps={{ fontWeight: 500, variant: "body2" }}
        >
          {t("group.createNewGroup")}
        </ListItemText>
      </MenuItem>
      <MenuItem onClick={pick(onUploadImport)}>
        <ListItemText
          primaryTypographyProps={{ fontWeight: 500, variant: "body2" }}
        >
          {t("group.importGroups")}
        </ListItemText>
      </MenuItem>
    </Menu>
  )
}

export default AddGroupMenu
